/**
 * Agentic Payment Offers - Shared Constants
 */

// Pagination
export const ITEMS_PER_PAGE = 20;
export const SEARCH_DEBOUNCE_MS = 300;

// Offer types
export const OFFER_TYPES = {
  ALL: "all",
  LONG: "long",
  SHORT: "short",
};

// Offer statuses (matches admin API filter values)
export const OFFER_STATUSES = {
  ALL: "all",
  ACTIVE: "active",
  LIVE: "live",
  EXPIRED: "expired",
  SETTLED: "settled",
  DELISTED: "delisted",
  DELETED: "deleted",
  DISABLED: "disabled",
  CUTOFF_PASSED: "cutoff_passed",
};
